import React from "react";
import { ThemeProvider } from "@mui/material/styles";
import ScopedCssBaseline from "@mui/material/ScopedCssBaseline";
import EmployeeLayout from "./EmployeeLayout";
import { ToastProvider } from "../admin/components/ToastProvider";
import { employeeTheme } from "./theme/employeeTheme";
import "./theme/employee.css";

const EmployeeApp: React.FC = () => (
  <ThemeProvider theme={employeeTheme}>
    <ScopedCssBaseline className="pn-employee" sx={{ minHeight: "100vh" }}>
      <ToastProvider>
        <EmployeeLayout />
      </ToastProvider>
      <div id="pn-employee-portal" className="pn-employee" />
    </ScopedCssBaseline>
  </ThemeProvider>
);

export default EmployeeApp;
